
    module.exports = {
      render: function(){with(this){return _c('div',{staticClass:"checkbox-panels"},[_c('div',{staticClass:"panel-checkboxes"},_l((panels),function(panel){return _c('div',{staticClass:"panel-checkbox",on:{"click":function($event){$event.stopPropagation();return changePanel(panel)}}},[_c('div',{class:[{'active': current === panel},'checkbox']}),_v(_s(panel.title))])}),0),_t("default")],2)}},
      staticRenderFns: []
    };
  